module.exports = "/img/42.76feb5.webp";